import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthService } from "./services/auth/auth.service";

import { AppComponent } from "./app.component";
import { HomeComponent } from "./generic/components-custom/agenda-custom/agenda-custom.component";
import { DbSchemaCustomComponent } from "./generic/components-custom/db-schema-custom/db-schema-custom.component";
import { LoadInsertInfoComponent } from "./generic/components-custom/load-insert-info/load-insert-info.component";
import { OrganizationChartCustomComponent } from "./generic/components-custom/organization-chart-custom/organization-chart-custom.component";

import { Values } from "../values/values";
import { EndpointService } from "./services/generic/endpoint.service";
import { EndpointRustService } from "./services/generic/endpoint-rust.service";
import { EndpointClientService } from "./services-client/endpoint-client.service";
import { ActivitiesService } from "./services/activities/activities.service";
import {
  NgbModalModule,
  NgbModule,
  NgbPopoverModule,
} from "@ng-bootstrap/ng-bootstrap";


import { LoginComponent, PrivacyDialog } from "./login/login.component";
import { CanvasWindowGenericComponent } from "./canvas-window-generic/canvas-window-generic.component";
import { CanvasEditorComponent } from "./canvas-window-generic/canvas-editor/canvas-editor.component";
import { HistoryWindowChangesComponent } from "./history-window-changes/history-window-changes.component";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatRippleModule,
} from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatInputModule } from "@angular/material/input";
import { TextFieldModule } from "@angular/cdk/text-field";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCardModule } from "@angular/material/card";
import { ContainerDeferComponent } from "./generic/components/container-defer/container-defer.component";
import { AgmCoreModule } from "@agm/core";
import { CarouselModule } from "primeng/carousel";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MultiselectDropdownModule } from "angular-2-dropdown-multiselect";
import { ImageUploadModule } from "angular2-image-upload";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { MomentModule } from "angular2-moment";
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

import {
  AngularEditorModule,
  AngularEditorService,
} from "@kolkov/angular-editor";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NgDompurifyModule } from "@tinkoff/ng-dompurify";
// Translations
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Utils
import { PredefinedValuesLoaderService } from "./services/LoadPredefinedValuesServices";
import { LoadExternValuesService } from "./services/LoadExternValuesService";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";
import { FlatpickrModule } from "angularx-flatpickr";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatIconModule } from "@angular/material/icon";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatMenuModule } from "@angular/material/menu";
import { MatChipsModule } from "@angular/material/chips";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatStepperModule } from "@angular/material/stepper";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from '@angular/material/slider';
import { FlexLayoutModule } from "@angular/flex-layout";
import { CDK_DRAG_CONFIG, DragDropModule } from "@angular/cdk/drag-drop";

//dialogs
import { DeleteConfirmDialog } from "./utils/delete-confirm-dialog/delete-confirm-dialog";

// bottom sheets
import { BottomSheetImageSelector } from "./utils/bottom-sheet-image-selector/bottom-sheet-image-selector";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { SideNavService } from "./utils/SideNavService";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MessageDialogComponent } from "./utils/message-dialog/message-dialog.component";
import { ResetPasswordComponent } from "./login/reset-password/reset-password.component";
import { SetPasswordComponent } from "./login/set-password/set-password.component";
import localeEs from "@angular/common/locales/es";
import { DragAndDropModule } from "angular-draggable-droppable";

import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from "ng-pick-datetime";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import {
  NotificationsComponent,
  SafeStylePipe,
} from "./generic/components-custom/agenda-custom/subcomponents/notifications/notifications.component";

import { MatGoogleMapsAutocompleteModule } from "@angular-material-extensions/google-maps-autocomplete";
import { SafePipe } from "./utils/Pipe/SafePipe";

// Joan: Error en la versió 14 - Ho comento perquè sembla que no es fa servir
//import {MatVideoModule} from 'mat-video';
import { SocketIoConfig, SocketIoModule } from "ngx-socket-io";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { BillComponent } from "./bill/bill.component";
import { AddMovinCoinComponent } from "./bill/subcomponent/add-movin-coin.component";
import { AutoAdviceHomeComponent } from "./auto-advice-home/auto-advice-home.component";
import { StripePaymentComponent } from "./stripe/stripe-payment/stripe-payment.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { AdviceReportService } from "./services/advice-report/advice-report.service";
import { MarketplaceComponent } from "./marketplace/marketplace/marketplace.component";
import { MarketplaceCardComponent } from "./marketplace/marketplace-card/marketplace-card.component";
import { ConfigDialogComponent } from "./marketplace/config-dialog/config-dialog.component";
import { YouTubePlayerModule } from "@angular/youtube-player";
import { ContainerComponent } from "./places/container/container.component";
import { CarouselComponent } from "./places/carousel/carousel.component";
import { ConfigurationComponent } from "./places/checkout-components/configuration/configuration.component";
import { DependenciesComponent } from "./places/checkout-components/dependencies/dependencies.component";
import { CheckoutComponent } from "./places/checkout-components/checkout/checkout.component";
import { BuyMovinsComponent } from "./places/checkout-components/buy-movins/buy-movins.component";
import { GeneralComponent } from "./places/checkout-components/general/general.component";
import { MovinsHistoryComponent } from "./places/movins-history/movins-history.component";
import { ModuleConfigComponent } from "./places/module-config/module-config.component";
import { LocalStorageService } from "./services/local-storage.service";
import { ChatComponent } from "./chat/chat.component";
import { ScrollingModule } from "@angular/cdk/scrolling";

import { SwapAccountComponent } from "./swap-account/swap-account.component";

import { SelectGroupUsersComponent } from "./chat/select-group-users/select-group-users.component";
import { ChatGroupInfoComponent } from "./chat/chat-group-info/chat-group-info.component";
import { BottomSheetEditUserGroupComponent } from "./chat/bottom-sheet-edit-user-group/bottom-sheet-edit-user-group.component";
import { BottomSheetNewChatContactComponent } from "./chat/bottom-sheet-new-chat-contact/bottom-sheet-new-chat-contact.component";
import { FilterPipe } from "./chat/filter.pipe";
import { BottomSheetAddUserToGroupComponent } from "./chat/bottom-sheet-add-user-to-group/bottom-sheet-add-user-to-group.component";
import { FilterUsersPipe } from "./generic/components-custom/agenda-custom/filter-users.pipe";
import { AgendaSettingsComponent } from "./generic/components-custom/agenda-custom/subcomponents/agenda-settings/agenda-settings.component";
import { MarketplaceGeneralComponent } from "./places/marketplace-stepper/marketplace-general/marketplace-general.component";
import { GenericComponent } from "./generic/generic.component";
import { ButtonComponent } from "./generic/components/button/button.component";
import { BottomsheetMenuComponent } from "./generic/components/button/bottomsheet-menu/bottomsheet-menu.component";
import { GraphsComponent } from "./generic/components/graphs/graphs.component";
import { FormComponent } from "./generic/components/form/form.component";
import { CheckboxComponent } from "./generic/components/checkbox/checkbox.component";
import { MenuComponent } from "./generic/components/menu/menu.component";
import { MenuGenericComponent } from "./menu-generic/menu-generic.component";
import { MenuGenericElementsComponent } from "./menu-generic/menu-generic-elements/menu-generic-elements.component";
import { MenuGenericElementComponent } from "./menu-generic/menu-generic-element/menu-generic-element.component";
import { InputComponent } from "./generic/components/input/input.component";
import { TwoDecimalDirective } from "./generic/components/input/two-decimal.directive";
import { CodeFileComponent } from "./generic/components/code-file/code-file.component";
import { TimerCountComponent } from "./generic/components/timer-count/timer-count.component";
import { SignComponent } from "./generic/components/sign/sign.component";
import { TabComponent } from "./generic/components/tab/tab.component";
import { TableComponent } from "./generic/components/table/table/table.component";
import { BottomSheetFilterTableComponent } from "./generic/components/table/bottom-sheet-filter-table/bottom-sheet-filter-table.component";
import { ChipAutocompleteComponent } from "./generic/components/table/bottom-sheet-filter-table/chip-autocomplete/chip-autocomplete.component";
import { DateRangePickerComponent } from "./generic/components/table/bottom-sheet-filter-table/date-range-picker/date-range-picker.component";
import { TableViewsComponent } from "./generic/components/table/table-views/table-views.component";
import { TableGroupsComponent } from "./generic/components/table/table-groups/table-groups.component";
import { SelectionComponent } from "./generic/components/selection/selection.component";
import { ExpansionComponent } from "./generic/components/expansion/expansion.component";
import { StepperComponent } from "./generic/components/stepper/stepper.component";
import { CardComponent } from "./generic/components/card/card.component";
import { ListComponent } from "./generic/components/list/list.component";
import { BottomSheetComponent } from "./generic/components/bottom-sheet/bottom-sheet.component";
import { TextComponent } from "./generic/components/text/text.component";
import { TrafficLightComponent } from "./generic/components/traffic-light/traffic-light.component";
import { YoutubeComponent } from "./generic/components/youtube/youtube.component";
import { SearchPortalsComponent } from "./search-portals/search-portals.component";
import { PortalWarningDialogComponent } from "./search-portals/subcomponents/portal-warning-dialog/portal-warning-dialog.component";
import { BajaDialogComponent } from "./marketplace/baja-dialog/baja-dialog.component";
import { ShoppingCartComponent } from "./places/shopping-cart/shopping-cart.component";
import { DemoDialogComponent } from "./demo-dialog/demo-dialog.component";
import { NgxFreshChatModule } from "ngx-freshchat";

import { LoginScreenComponent } from "./login/login-screen/login-screen.component";
import { ShoppingCartDeleteDialogComponent } from "./places/shopping-cart/shopping-cart-delete-dialog/shopping-cart-delete-dialog.component";
import { GenericContainerComponent } from "./generic-container/generic-container.component";
import { DialogComponent } from "./generic/components/dialog/dialog.component";
import { BarRatingModule } from "ngx-bar-rating";
import { DividerComponent } from "./generic/components/divider/divider.component";
import { BoxComponent } from "./generic/components/box/box.component";
import { SidenavComponent } from "./generic/components/sidenav/sidenav.component";
import { PostponeEvent } from "./generic/components-custom/agenda-custom/subcomponents/postpone-event/postpone-event";
import { MotivoCancelacion } from "./generic/components-custom/agenda-custom/subcomponents/motivo-cancelacion/motivo-cancelacion";
import { BottomSheetFinishedEvents } from "./generic/components-custom/agenda-custom/subcomponents/bottom-sheet-finished-events/bottom-sheet-finished-events";
import { CreateGroupDialog } from "./generic/components-custom/agenda-custom/subcomponents/bottom-sheet-shared-calendar/subcomponents/create-group-dialog/create-group-dialog";
import { BottomSheetSharedCalendar } from "./generic/components-custom/agenda-custom/subcomponents/bottom-sheet-shared-calendar/bottom-sheet-shared-calendar";
import { ToolsCustomComponent } from "./generic/components-custom/tools-custom/tools-custom.component";

import { Dispatcher } from "./services/dispatcher";
import { PushNotificationsService } from "./services/pushNotifications.service";

import { ManageCategoriesDialog } from "./generic/components-custom/agenda-custom/subcomponents/manage-categories-dialog/manage-categories-dialog";
import { ColorPickerDialog } from "./activities/subcomponents/color-picker-dialog/color-picker-dialog";
import { AllEventsListDialog } from "./generic/components-custom/agenda-custom/subcomponents/all-events-list-dialog/all-events-list-dialog";
import { DeviceDetectorModule } from "ngx-device-detector";
import { FlatImagesCustomComponent } from "./generic/components-custom/flat-images-custom/flat-images-custom.component";
import { EventsConditionsCustomComponent } from "./generic/components-custom/events-conditions-custom/events-conditions-custom.component";
import { EventsConditionsCustomLoopComponent } from "./generic/components-custom/events-conditions-custom/events-conditions-custom-loop/events-conditions-custom-loop.component";
import { EventsConditionsCustomElementComponent } from "./generic/components-custom/events-conditions-custom/events-conditions-custom-element/events-conditions-custom-element.component";
import { EventsTemplateCustomComponent } from "./generic/components-custom/events-template-custom/events-template-custom.component";
import { EventsTemplateCustomLoopComponent } from "./generic/components-custom/events-template-custom/events-template-custom-loop/events-template-custom-loop.component";
import { EventsTemplateCustomElementComponent } from "./generic/components-custom/events-template-custom/events-template-custom-element/events-template-custom-element.component";
import { MessagesTemplateCustomComponent } from "./generic/components-custom/messages-template-custom/messages-template-custom.component";
import { NotificationsCustomComponent } from "./generic/components-custom/notifications-custom/notifications-custom.component";
import { SocialMediaCustomComponent } from "./generic/components-custom/rrss-home-custom/rrss-home-custom.component";
import { BuyMovinsCustomComponent } from "./generic/components-custom/buy-movins-custom/buy-movins-custom.component";
import { FileUploadComponent } from "./generic/components/file-upload/file-upload.component";
import { DragAndDropDirective } from "./generic/components/file-upload/drag-and-drop.directive";
import { LocationComponent } from "./generic/components/location/location.component";
import { CanvaComponent } from "./generic/components/canva/canva.component";
import { CarouselGenericComponent } from "./generic/components/carousel-generic/carousel-generic.component";
import { ChooseAccountCalendarComponent } from "./generic/components-custom/agenda-custom/subcomponents/choose-account-calendar/choose-account-calendar.component";
import { SafeHtmlPipe } from "./safe-html.pipe";
import * as CanvasJSAngularChart from "../assets/canvasjs.angular.component";
import { GoogleMapsComponent } from "./generic/components/google-maps/google-maps.component";
import { ChipCreatorCustomComponent } from "./generic/components-custom/chip-creator-custom/chip-creator-custom.component";
import { GenericCreatorCustomComponent } from './generic/components-custom/generic-creator-custom/generic-creator-custom.component';
import { AddGenericElementDialogComponent } from './generic/components-custom/generic-creator-custom/add-generic-element-dialog/add-generic-element-dialog.component';
import { GenericCustomCreatorOptionsComponent } from './generic/components-custom/generic-creator-custom/generic-custom-creator-options/generic-custom-creator-options.component';
import { GenericCustomCreatorGeneraldetailsComponent } from './generic/components-custom/generic-creator-custom/generic-custom-creator-generaldetails/generic-custom-creator-generaldetails.component';
import { JourneyCreatorCustomComponent } from './generic/components-custom/journey-creator-custom/journey-creator-custom.component';
import { AddJourneyElementDialogComponent } from './generic/components-custom/journey-creator-custom/add-journey-element-dialog/add-journey-element-dialog.component';
import { NodeService } from "./services/generic/node.service";
import { NodesContainerComponent } from "./generic/components-custom/nodes-container/nodes-container.component";
import { NodeComponent } from "./generic/components-custom/node/node.component";
import { RestaurantPedidoActualCartaCustomComponent } from "./generic/components-custom/restaurant-pedido-actual-carta-custom/restaurant-pedido-actual-carta-custom.component";
import { RestaurantPedidosMesasCustomComponent } from "./generic/components-custom/restaurant-pedidos-mesas-custom/restaurant-pedidos-mesas-custom.component";
import { RedsysCustomComponent } from "./generic/components-custom/redsys-custom/redsys-custom.component"
import { PaycometCustomComponent } from "./generic/components-custom/paycomet-custom/paycomet-custom.component";
import { PaypalCustomComponent } from "./generic/components-custom/paypal-custom/paypal-custom.component";
import { StripeCustomComponent } from "./generic/components-custom/stripe-custom/stripe-custom.component";
import { TableGenericCreatorComponent } from "./generic/components/table/table-generic-creator/table-generic-creator.component";
import { TableContainerComponent } from "./generic/components/table/table-container/table-container.component";
import { TableGraphsComponent } from "./generic/components/table/table-graphs/table-graphs.component";
import { TableAgendaComponent } from "./generic/components/table/table-agenda/table-agenda.component";
import { TableGanttComponent } from "./generic/components/table/table-gantt/table-gantt.component";
import { NgxEmojiPickerModule } from 'ngx-emoji-picker';
import { NgxPayPalModule } from 'ngx-paypal';
import { CalendarComponent } from "./generic/components/calendar/calendar.component";
import { CdkStepperModule } from "@angular/cdk/stepper";

import { NgxGraphModule } from '@swimlane/ngx-graph';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { SnackbarComponent } from './generic/components/snackbar/snackbar.component';
import { AdvicebarComponent } from './generic/components/advicebar/advicebar.component';

const config: SocketIoConfig = {
  url: "wss://server.4dmovin.com",
  options: {
    reconnectionDelay: 1000,
    reconnection: true,
    reconnectionAttempts: 2,
    transports: ["websocket"],
    // default is ['polling', 'websocket']
    // rejectUnauthorized: false,
    // enabledTransports: ['ws', 'wss']
  },
};

const DragConfig = {
  zIndex: 999999999999,
};

var CanvasJSChart = CanvasJSAngularChart.CanvasJSChart;

registerLocaleData(localeEs);

const appRoutes: Routes = [
  /* PATHS NO GENERIC */
  { path: "joinGroup/:id", component: AppComponent },

  { path: "**", component: GenericContainerComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DbSchemaCustomComponent,
    LoadInsertInfoComponent,
    OrganizationChartCustomComponent,
    SwapAccountComponent,
    LoginComponent,
    CanvasWindowGenericComponent,
    CanvasEditorComponent,
    HistoryWindowChangesComponent,

    // Utils
    ToolsCustomComponent,
    DeleteConfirmDialog,
    ManageCategoriesDialog,
    ColorPickerDialog,
    AllEventsListDialog,
    MessageDialogComponent,
    ResetPasswordComponent,
    SetPasswordComponent,
    BottomSheetImageSelector,
    BottomSheetFinishedEvents,
    PrivacyDialog,
    PostponeEvent,
    BottomSheetSharedCalendar,
    ChooseAccountCalendarComponent,
    BottomsheetMenuComponent,
    CreateGroupDialog,
    MotivoCancelacion,
    NotificationsComponent,
    SafePipe,
    BillComponent,
    AddMovinCoinComponent,
    AutoAdviceHomeComponent,
    StripePaymentComponent,
    SafeStylePipe,
    MarketplaceComponent, MarketplaceCardComponent,
    ConfigDialogComponent,
    ContainerComponent,
    CarouselComponent,
    ConfigurationComponent,
    DependenciesComponent,
    CheckoutComponent,
    BuyMovinsComponent,
    GeneralComponent,
    MovinsHistoryComponent,
    ModuleConfigComponent,
    ChatComponent,
    SwapAccountComponent,
    SelectGroupUsersComponent,
    ChatGroupInfoComponent,
    BottomSheetEditUserGroupComponent,
    BottomSheetNewChatContactComponent,
    FilterPipe,
    BottomSheetAddUserToGroupComponent,
    FilterUsersPipe,
    AgendaSettingsComponent,
    MarketplaceGeneralComponent,
    SearchPortalsComponent,
    PortalWarningDialogComponent,
    BajaDialogComponent,
    ShoppingCartComponent,
    DemoDialogComponent,
    ShoppingCartComponent,
    GenericComponent,
    ButtonComponent,
    CanvasJSChart,
    GraphsComponent,
    FormComponent,
    CheckboxComponent,
    MenuComponent,
    MenuGenericComponent,
    MenuGenericElementsComponent,
    MenuGenericElementComponent,
    InputComponent,
    TwoDecimalDirective,
    CodeFileComponent,
    TimerCountComponent,
    SignComponent,
    FileUploadComponent,
    DragAndDropDirective,
    LocationComponent,
    TabComponent,
    TableComponent,
    BottomSheetFilterTableComponent,
    TableViewsComponent,
    TableGroupsComponent,
    ChipAutocompleteComponent,
    DateRangePickerComponent,
    SelectionComponent,
    ExpansionComponent,
    StepperComponent,
    CardComponent,
    CarouselGenericComponent,
    ListComponent,
    TextComponent,
    TrafficLightComponent,
    BottomSheetComponent,
    YoutubeComponent,
    PortalWarningDialogComponent,
    DemoDialogComponent,
    LoginScreenComponent,
    ShoppingCartDeleteDialogComponent,
    GenericContainerComponent,
    GenericContainerComponent,
    DialogComponent,
    DividerComponent,
    BoxComponent,
    SidenavComponent,
    ColorPickerDialog,
    ManageCategoriesDialog,
    AllEventsListDialog,
    ContainerDeferComponent,
    FlatImagesCustomComponent,
    EventsConditionsCustomComponent,
    EventsConditionsCustomLoopComponent,
    EventsConditionsCustomElementComponent,
    EventsTemplateCustomComponent,
    EventsTemplateCustomLoopComponent,
    EventsTemplateCustomElementComponent,
    MessagesTemplateCustomComponent,
    GenericCreatorCustomComponent,
    AddGenericElementDialogComponent,
    GenericCustomCreatorOptionsComponent,
    GenericCustomCreatorGeneraldetailsComponent, NotificationsCustomComponent,
    SocialMediaCustomComponent,
    BuyMovinsCustomComponent,
    CanvaComponent,
    CarouselGenericComponent,
    ChooseAccountCalendarComponent,
    SafeHtmlPipe,
    GoogleMapsComponent,
    ChipCreatorCustomComponent,
    JourneyCreatorCustomComponent,
    AddJourneyElementDialogComponent,
    NodesContainerComponent,
    TableGenericCreatorComponent,
    TableContainerComponent,
    TableGraphsComponent,
    TableAgendaComponent,
    TableGanttComponent,
    NodeComponent,
    RestaurantPedidoActualCartaCustomComponent,
    RestaurantPedidosMesasCustomComponent,
    RedsysCustomComponent,
    PaycometCustomComponent,
    PaypalCustomComponent,
    StripeCustomComponent,
    CalendarComponent,
    SnackbarComponent,
    AdvicebarComponent
  ],

  imports: [
    //[StripeModule.forRoot("pk_test_51NBDXeF0nPp3VXRASsgNRGwmoi6AUodzj5TSnmP21y5rXr8oXSx9LqWw7y4Ex9K5bEXhUIcb4eAMffhZZPKCfY9500urthblRr")], // Daniel
    BarRatingModule,
    CdkStepperModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: "never" }),
    MatSnackBarModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatPaginatorModule,
    CommonModule,
    NgbModalModule,
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled",
      relativeLinkResolution: "legacy",
    }),
    MultiselectDropdownModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    ImageUploadModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    NgxFreshChatModule,
    NgbModule.forRoot(),
    AngularEditorModule,
    MatButtonToggleModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDDD_E7LB2dKMu2qJniasF0fMatAyfmaXE",
    }),
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),

    DragAndDropModule,
    NgbPopoverModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatDialogModule,
    MatGridListModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatIconModule,
    MatExpansionModule,
    MatStepperModule,
    MatMenuModule,
    MatChipsModule,
    MatTooltipModule,
    MatListModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatCardModule,
    MatProgressSpinnerModule,
    DeviceDetectorModule.forRoot(),
    MatBottomSheetModule,
    NgDompurifyModule,
    MatProgressBarModule,
    MatToolbarModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxMaterialTimepickerModule,
    MatGoogleMapsAutocompleteModule,
    AgmCoreModule.forRoot(),
    FlexLayoutModule,
    DragDropModule,
    TextFieldModule,
    OverlayModule,
    PortalModule,
    NgxEmojiPickerModule,
    NgxPayPalModule,
    NgxGraphModule,
    MonacoEditorModule.forRoot(),

    // Joan: error en la versió 14 - Ho comento perquè sembla que no es fa servir
    //MatVideoModule,
    SocketIoModule.forRoot(config),
    ClipboardModule,
    CarouselModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    YouTubePlayerModule,
    ScrollingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],

  providers: [
    Dispatcher,
    AngularEditorService,
    PushNotificationsService,
    EndpointService,
    EndpointRustService,
    EndpointClientService,
    AuthService,
    ActivitiesService,
    PredefinedValuesLoaderService,
    BottomSheetFilterTableComponent,
    TableViewsComponent,
    TableGroupsComponent,
    ChipAutocompleteComponent,
    DateRangePickerComponent,
    LoadExternValuesService,
    DatePipe,
    SideNavService,
    LocalStorageService,
    AdviceReportService,
    FilterUsersPipe,
    DialogComponent,
    BottomSheetComponent,
    MarketplaceGeneralComponent,
    { provide: CDK_DRAG_CONFIG, useValue: DragConfig },
    { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    NodeService,
    CalendarComponent
  ],

  exports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogComponent,
    ToolsCustomComponent,
    CdkStepperModule,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
